module.exports = __webpack_public_path__ + "img/logo_color.3e6f8eb1.svg";